import { gql } from '@apollo/client';

export const FETCH_LARK_USER_ID = gql`
  query FetchLarkUserIdByContact($input: FetchLarkUserIdInput!) {
    fetchLarkUserIdByContact(input: $input) {
      success
      larkId
      message
      messageCode
    }
  }
`;

export interface FetchLarkUserIdInput {
  phone?: number | null;
  countryCode?: number | null;
  email?: string | null;
}

export interface FetchLarkUserIdResultType {
  success: boolean;
  larkId?: string | null;
  message: string;
  messageCode?: string | null;
}

export interface FetchLarkUserIdByContactResponse {
  fetchLarkUserIdByContact: FetchLarkUserIdResultType;
}

export interface FetchLarkUserIdByContactVariables {
  input: FetchLarkUserIdInput;
}
